import Axios from 'axios'
import { getApiBase } from './api-base'

export function createAxios() {
  return Axios.create({
    baseURL: getApiBase()
  })
}
